/**
 * Represents key milestones in an order's lifecycle
 */
export enum LifeCycleEvent {
  Unknown = -2,
  Canceled = -1,
  PrePlanning = 0,
  Started = 1,
  LastTruckLoaded = 2,
  Delivered = 3,
  Invoiced = 4
}

/**
 * Valid process events (excludes Unknown and Canceled states)
 */
export type ProcessEvent = Exclude<LifeCycleEvent, LifeCycleEvent.Unknown | LifeCycleEvent.Canceled>

/**
 * Type guard to check if an event is a valid process event
 */
export const isProcessEvent = (event: LifeCycleEvent): event is ProcessEvent => {
  return event >= LifeCycleEvent.PrePlanning
}
